import React from 'react';
import { Box, Typography } from '@mui/material';

// Shown when a tenant has JIT disabled. The copy deliberately does NOT say "JIT is
// unavailable" — active sessions stay visible and revocable, and only NEW requests and
// approvals are blocked.
export default function JITDisabled() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', px: 3, textAlign: 'center' }}>
      <Typography sx={{ fontFamily: 'Metropolis, sans-serif', fontWeight: 600, fontSize: '1.25rem', color: '#253E66', mb: 1 }}>
        Just-In-Time access is turned off
      </Typography>
      <Typography sx={{ fontFamily: 'Metropolis, sans-serif', fontSize: '0.9rem', color: '#666666', maxWidth: 520 }}>
        Your organization has disabled new Just-In-Time access requests. Any access you already have stays active and will expire on its normal schedule — you can still view and revoke your sessions.
      </Typography>
    </Box>
  );
}
